module.exports = __webpack_public_path__ + "static/image/reporter-p2.svg?09943bc5e19e16c3bdebd81bf022bed5";